module.exports = __webpack_public_path__ + "img/MatPL-4.7ac7a1ad.png";